import React, { useState } from 'react'
import LogIn from '../components/Login/LogIn'

const LogInPage = () => {

  return (
  <LogIn/>
  )
}



export default LogInPage
